<template>
  <van-sticky :offset-top="0">
    <demo-block :title="('')">
      <van-nav-bar :title="('充电桩位置信息')" :left-text="('返回')" left-arrow @click-left="this.$router.push('chargeindex')">
        <template #right>
          <van-icon v-if="paytype===0 || paytype ===1" name="wechat-pay" size="18" />
          <van-icon v-if="paytype===2" name="alipay" size="18" />
        </template>
      </van-nav-bar>
    </demo-block>
  </van-sticky>
  <div class="map-annotator">
    <div class="map-container">
      <div id="map"></div>
      <div class="current-location" @click="locateMe">
        <van-icon name="location-o" size="18" />
      </div>
    </div>
  </div>
  <van-overlay :show="loading" >
    <view class="wrapper">
      <view class="block" catch:tap="noop">
        <van-loading size="24px" color="#ffffff">{{ loadcontent }}</van-loading>
      </view>
    </view>
  </van-overlay>
</template>

<script>
import { GetBrowserType } from '../../utils/tools/index'
import { requestChargeStationList } from '../../api/api'
import {
    Grid,
    GridItem,
    Image,
    Tabbar,
    TabbarItem,
    Swipe,
    SwipeItem,
    Tag,
    Cell,
    CellGroup,
    Row,
    Col,
    CouponCell,
    CouponList,
    Popup,
    Icon,
    Dialog,
    Toast,
    NoticeBar,
    ActionBar,
    ActionBarButton,
    ActionBarIcon,
    Button,
    Sticky,
    NavBar,
    Overlay,
    Loading
  } from "vant";
export default {
  data() {
    return {
      map: null,
      markers: [],
      loading: false,
      panelCollapsed: true,
      markerForm : {
        title: '',
        description: '',
        position: null
      },
      lsChargeStation: [],
      paytype: 0,
      editingMarker: false,
      currentPosition: {lat: 120.793577, lng: 31.612814},
      groundPointsOverlay: [],
      /*
        {title: '汽车充电桩' , content: '个，1个空闲', lat: 120.793577, lng: 31.612814,color: '#01C328' },
        {title: '两轮车充电桩' , content: '2个，8个空闲', lat: 120.793577, lng: 31.610814,color: '#EE3030' },
        {title: '汽车充电桩' , content: '3个，1个空闲', lat: 120.793577, lng: 31.612815,color: '#01C328' },
        {title: '两轮车充电桩' , content: '4个，8个空闲', lat: 120.793577, lng: 31.510854,color: '#EE3030' },
        {title: '汽车充电桩' , content: '5个，1个空闲', lat: 120.793577, lng: 31.612864,color: '#01C328' },
        {title: '两轮车充电桩' , content: '6个，8个空闲', lat: 120.793577, lng: 31.610874,color: '#EE3030' },
      ],
      */
      gParse: null,
      obj: { _scale: 20 },
      loadcontent: '加载中...'
    };
  },
  components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Image.name]: Image,
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Cell.name]: Cell,
      [Tag.name]: Tag,
      [Overlay.name]: Overlay,
      [Sticky.name]: Sticky,
      [NavBar.name]: NavBar,
      [Col.name]: Col,
      [Row.name]: Row,
      [CouponCell.name]: CouponCell,
      [CouponList.name]: CouponList,
      [Popup.name]: Popup,
      [Icon.name]: Icon,
      [Dialog.Component.name]: Dialog.Component,
      [Toast.name]: Toast,
      [NoticeBar.name]: NoticeBar,
      [ActionBar.name]: ActionBar,
      [ActionBarButton.name]: ActionBarButton,
      [ActionBarIcon.name]: ActionBarIcon,
      [Button.name]: Button,
      [CellGroup.name]: CellGroup,
      [Loading.name]: Loading,
    },
    i18n: {
      "zh-CN": {
        text: "文字",
        route: "页面导航",
        gutter: "格子间距",
        square: "正方形格子",
        columnNum: "自定义列数",
        customContent: "自定义内容",
        urlRoute: "URL 跳转",
        vueRoute: "路由跳转",
        showBadge: "徽标提示",
        horizontal: "内容横排",
      },
      "en-US": {
        text: "Text",
        route: "Route",
        gutter: "Gutter",
        square: "Square",
        columnNum: "Column Num",
        customContent: "Custom Content",
        urlRoute: "URL",
        vueRoute: "Vue Router",
        showBadge: "Show Badge",
        horizontal: "Horizontal",
      },
  },
  mounted() {
    this.loading = true;
    this.paytype = GetBrowserType()
    this.loadBaiduMap();
  },
  methods: {
    loadBaiduMap() {
       // 动态加载百度地图API
      this.loadChargeStationList()
      // 检查百度地图API是否已加载
      console.log(window.BMapGL)
      if (typeof window.BMapGL != 'undefined') {
        console.log('start init baidu maps')
        this.initMap();
        return;
      }
      
      // 设置回调函数
      window.baiduMapInit = () => {
        this.initMap();
      };
      const script = document.createElement('script');
      script.src = 'https://api.map.baidu.com/api?type=webgl&v=1.0&ak=8InEpHvF150rkPWMUYQgCfoeL2kiJImK&callback=baiduMapInit';
      document.head.appendChild(script);
     
    },
    // 初始化百度地图
    initMap() {
      console.log('start initmap function ..')
      this.map = new window.BMapGL.Map('map');
      console.log('init is over:',this.map)
      const point = new window.BMapGL.Point(120.793577, 31.612814); //  
      this.map.centerAndZoom(point, 18);
      this.map.enableScrollWheelZoom(true);
      // 尝试获取用户当前位置
      this.locateMe();
      // this.loadGroundPoint();
      // this.addGroundPoint();
      // this.loading = false;
    },
    locateMe() {
      const _this =this
      this.loading = true
      this.map.clearOverlays(); 
      var geolocation = new window.BMapGL.Geolocation();
      geolocation.getCurrentPosition(function(r){
        if(this.getStatus() == 0){
            var mk = new window.BMapGL.Marker(r.point);
            _this.currentPosition = r
            _this.map.addOverlay(mk);
            _this.map.panTo(r.point);
            Dialog.alert({
              title: '定位信息',
              message: '您的位置：' + r.point.lng + ',' + r.point.lat,
            })
            console.log('定位信息：' , _this.currentPosition)
            _this.loadGroundPoint();
            _this.addGroundPoint();
            _this.loading = false;
        }
        else {
            alert('failed' + this.getStatus());
            this.loading = false;
        }        
      });
    },
    // 移除地面点覆盖物
    removeGroundPoint() {
    },
    // 添加地面点覆盖物
    addGroundPoint(){
      console.log('开始增加信息');
      const _this = this
      this.lsChargeStation.forEach(item=>{
        // _this.map.centerAndZoom(new window.BMapGL.Point(item.lat, item.lng), 15);
        // 创建点标记
        console.log(item);
        console.log('创建标点' + item.termname)
        item.content='总计'+item.sumcount+'个插座，' + item.sumnousecount + '个空闲'
        var p=(item.sumnousecount*100)/item.sumcount
        if (p.sumnousecount>1) item.color='#EE3030'
        else item.color='#01C328'


        var point = new window.BMapGL.Point(item.lat, item.lng)
        var marker = new window.BMapGL.Marker(point, 
          { 
            icon: new window.BMapGL.SVGSymbol(window.BMapGL.SymbolShapeType.BMap_Symbol_SHAPE_POINT	, 
            {
              fillColor: item.color, 
              fillOpacity: 0.8,
              scale: 1.2,
              strokeOpacity: 1,
              // anchor: new window.BMapGL.Size(32, 32)
            }) 
          });

        _this.map.addOverlay(marker);
        // 创建信息窗口
        var opts = {
            width: 200,
            height: 100,
            title: item.termname
        };
        
        var infoWindow = new window.BMapGL.InfoWindow(item.content, opts);
        // 点标记添加点击事件
        marker.addEventListener('click', function () {
          console.log('点击位置');
          _this.map.openInfoWindow(infoWindow, point); // 开启信息窗口
        });
        marker.show();
      });
    },
    // 添加充电桩信息
    loadGroundPoint() {
        // 清空
      this.removeGroundPoint();
      // this.groundPointsOverlay = [];

    },
    async loadChargeStationList() {
      const res = await requestChargeStationList({accesstoken: this.$store.state.accesstoken})
      if(res.return_code==0) {
        this.lsChargeStation=res.data
        this.dialogShowChargeStation=true
      } else {
        Dialog.alert({
          title: '获取充电桩信息失败！',
          message: res.return_message,
        }).then(() => {
          console.log('onclose')
        });
        this.loading = false;
      }
    }
  },
  beforeUnmount() {
    // 组件销毁前清理地图实例
    this.loading = false;
    if (this.map!=undefined) {
      console.log(this.map)
      this.map.destroy();
    }
  }
};
</script>

 <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
  
    
    #app {
      height: 100vh;
      display: flex;
      flex-direction: column;
      position: relative;
    }

   
    .map-annotator {
      height: 100vh;
      display: flex;
      flex-direction: column;
      position: relative;
    }
    
     
    
    .map-container {
      flex: 1;
      position: relative;
    }
    
    #map {
      width: 100%;
      height: 100%;
    }
    .current-location {
      position: absolute;
      top: 85px;
      right: 15px;
      background: white;
      border-radius: 50%;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
      z-index: 10;
      cursor: pointer;
    }
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
     
   
  </style>
